import * as signalR from '@microsoft/signalr'
import { get as getCookie } from 'es-cookie'
import URL from 'src/api/url/api'

const connection = new signalR.HubConnectionBuilder()
  .configureLogging(signalR.LogLevel.Error)
  .withUrl(URL.SOCKET_URL, {
    skipNegotiation: true,
    transport: 1,
    withCredentials: true,
    accessTokenFactory: () => getCookie('token') || '',
  })
  .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
  .build()

// Shared start promise: multiple callers (each useEffect that needs the socket)
// can call startConnection() concurrently — they all await the same start
// instead of racing connection.start() which throws "Cannot start a connection
// that is not in the disconnected state." Reset on close so the next caller
// can re-establish if the connection dropped.
let startPromise = null

connection.onreconnected(connectionId => {
  console.info('SignalR reconnected', connectionId)
})

connection.onclose(error => {
  if (error) console.error('SignalR connection closed with error:', error)
  startPromise = null
})

const startConnection = async () => {
  if (connection.state === 'Connected') return
  if (!startPromise) {
    startPromise = connection.start().catch(err => {
      console.error('SignalR start failed:', err && err.toString && err.toString())
      startPromise = null
      throw err
    })
  }
  try {
    await startPromise
  } catch {
    // Swallow — callers that need a live connection will see state !== 'Connected'.
  }
}

const addMessageReceivedListener = (cardId, callback) => {
  connection.on('ReceiveMessage', message => {
    callback(message)
  })
}
const addCourseCreationMessageReceivedListener = callback => {
  connection.on('ReceiveMessage', message => {
    callback(message)
  })
}
const addTranslationCompleteListener = callback => {
  connection.on('TranslationComplete', callback)
}
const removeTranslationCompleteListener = callback => {
  connection.off('TranslationComplete', callback)
}
const addCollectionDuplicationCompleteListener = callback => {
  connection.on('CollectionDuplicationComplete', callback)
}
const removeCollectionDuplicationCompleteListener = callback => {
  connection.off('CollectionDuplicationComplete', callback)
}

export {
  startConnection,
  addMessageReceivedListener,
  addCourseCreationMessageReceivedListener,
  addTranslationCompleteListener,
  removeTranslationCompleteListener,
  addCollectionDuplicationCompleteListener,
  removeCollectionDuplicationCompleteListener,
}
